import { useFilterEmployeeScoreContext } from "./filter-employee-score.context";

export function FilterEmployeeScore() {
  const { dateFilterElement, reportFilterElements, clearFiltersElement } =
    useFilterEmployeeScoreContext();

  return (
    <div>
      <h2>Filters</h2>
      <p className="mb-4">
        Select the following filters you want to apply to the current table.
      </p>

      {dateFilterElement}
      {reportFilterElements}
      {clearFiltersElement}
    </div>
  );
}